export default "__VITE_ASSET__PGfCxe70__"